import React from 'react'

/**
 *
 * @typedef EmailInput
 * @property {(e) => void} onChange
 * @property {string=} placeholder
 * @property {string=} className
 * @property {string=} value
 * @property {import('react').CSSProperties=} style
 */

/**
 *
 * @param {EmailInput} props
 */
export function EmailInput({ onChange, placeholder, value, style, className, ...props }) {
  function handleChange(e) {
    const value = e.target.value
    if (value) {
      onChange(value.toLowerCase())
    } else {
      onChange(value)
    }
  }

  return (
    <input
      required
      className={className}
      type="email"
      name="email"
      onChange={handleChange}
      placeholder={placeholder}
      value={value}
      {...props}
      style={style}
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/EmailInput/index.js